import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Notification } from "@/types/Notification";

const initialState: Notification[] = [];

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    addNotification(
      state,
      action: PayloadAction<{ type: string; title: string; subtitle: string }>
    ) {
      state.push({
        id: new Date().getTime(),
        title: action.payload.title,
        type: action.payload.type,
        subtitle: action.payload.subtitle,
      });
    },
    removeNotification(state, action: PayloadAction<{ id: number }>) {

      return state.filter(
        (notification) => notification.id !== action.payload.id
      );
    },
    clearNotifications() {
      return [];  
    },
  },
});

export const { addNotification, removeNotification, clearNotifications } =
  notificationSlice.actions;
export default notificationSlice.reducer;
